export const Star = ({ selected, width = 32, height = 30 }: { selected?: boolean; width?: number; height?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${selected ? 'text-warning' : 'text-gray'} transition-colors`}
    >
      <g id="Unselected_Star_Rate">
        <path
          id="Vector"
          d="M15.6702 23.6815L15.9271 23.5278L16.1838 23.6816L25.0028 28.9632L22.6586 19.0192L22.5888 18.7232L22.8196 18.5251L30.6125 11.8352L20.3558 10.9706L20.0561 10.9453L19.938 10.6687L15.9264 1.27222L11.9056 10.6691L11.7874 10.9454L11.4879 10.9706L1.23123 11.8352L9.02417 18.5251L9.25493 18.7232L9.18515 19.0192L6.84083 28.9639L15.6702 23.6815Z"
          stroke="currentColor"
          fill={selected ? 'currentColor' : 'none'}
        />
      </g>
    </svg>
  )
}
